module.exports = __webpack_public_path__ + "img/prioritas_dfod_dg.4bda8f90.png";